import React from 'react';
import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const longdriveNoContratadoLayer: ServiceLayer = {
	header: 'Coberturas',
	title: 'Volkswagen Long Drive',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Con tu suscripción de mantenimiento, lo tendrás todo incluido en una única cuota mensual. Será mucho más cómodo,
			porque siempre podrás pasar por el taller sin preocuparte por cuánto te costará. Y sin entrada ni comisiones.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0130}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Estas son las suscripciones que puedes elegir:
			</Text>
			<Container wrap="always" padding={{ left: ContainerPadding.dynamic0050 }}>
				<Text appearance={TokenTextAppearance.copy200}>
					<List gutter={ListGutter.dynamic0020}>
						<ListItem>Standard: incluye el mantenimiento de tu coche.</ListItem>
						<ListItem>Advance: incluye el mantenimiento y cambio de piezas por desgaste de tu coche.</ListItem>
						<ListItem>Pro: incluye el mantenimiento, cambio de piezas por desgaste y neumáticos de tu coche.</ListItem>
					</List>
				</Text>
			</Container>

			<Text appearance={TokenTextAppearance.copy200}>
				Además, todos los planes incluyen asistencia en carretera 24/7 y coche de sustitución en caso de avería.
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-long-drive-cuadrado?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
	ctaText: 'Calcula tu cuota y contrátalo online',
	link: 'https://www.volkswagen.es/es/clientes/longdrive.html#suscripciones',
	descriptionFooter: (
		<Text appearance={TokenTextAppearance.copy200}>
			Si tienes contratado Volkswagen Long Drive, pero no aparecen aquí los detalles de tu plan, puedes consultarlos en
			el{' '}
			<CTA
				tag="a"
				emphasis="tertiary"
				href="https://www.fs-tools.es/volkswagenlongdriveservice"
				aria-label="Portal de Long Drive."
				target="_blank"
			>
				<Text color={TokenTextColor.primary}>portal de Long Drive.</Text>
			</CTA>
		</Text>
	),
};
